import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import * as api from '../lib/api';

const ScenarioContext = createContext(null);
export const useScenario = () => useContext(ScenarioContext);

export function ScenarioProvider({ children }) {
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const sc = await api.getActiveScenario();
      setActive(sc);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const sid = active?.id;
  return (
    <ScenarioContext.Provider value={{ active, sid, loading, error, reload, setActive }}>
      {children}
    </ScenarioContext.Provider>
  );
}
